export default "__VITE_ASSET__DCEV101E__"